import type { LucideIcon } from "lucide-react";
import { Inbox } from "lucide-react";
import type { ReactNode } from "react";
import { clsx } from "@/src/common/utils/clsx";

interface EmptyStateProps {
	icon?: LucideIcon;
	title: ReactNode;
	description?: ReactNode;
	action?: ReactNode;
	className?: string;
}

export function EmptyState({ icon: Icon = Inbox, title, description, action, className }: EmptyStateProps) {
	return (
		<div
			className={clsx(
				"flex flex-col items-center justify-center gap-3 rounded-l border border-dashed border-border bg-surface px-8 py-12 text-center",
				className,
			)}
		>
			<div className="flex size-12 items-center justify-center rounded-pill bg-background text-muted-foreground">
				<Icon className="size-5" />
			</div>
			<div className="flex max-w-sm flex-col gap-1">
				<p className="text-sm font-semibold text-foreground">{title}</p>
				{description ? <p className="text-xs text-muted-foreground">{description}</p> : null}
			</div>
			{action ? <div className="mt-2">{action}</div> : null}
		</div>
	);
}
